export enum Fraktion {
  WERWOLF = "WERWOLF",
  DORFBEWOHNER = "DORFBEWOHNER",
  ALLEINE = "ALLEINE",
  SWITCHER = "SWITCHER",
  NONE = "NONE",
}
